// Haitian Creole translations
export const ht: Record<string, string> = {
  'menu.dashboard': 'Tablo',
  'menu.customers': 'Kliyan',
  'menu.products': 'Pwodui',
  'menu.users': 'Itilizatè',
  'menu.settings': 'Paramèt',
  'menu.logout': 'Dekonekte',
  'dashboard.title': 'Tablo',
  'dashboard.newOrder': 'Nouvo Lòd',
  'order.title': 'Nouvo Lòd',
  'order.customer': 'Kliyan',
  'order.products': 'Pwodui',
  'order.total': 'Total',
  'users.title': 'Itilizatè',
  'users.name': 'Non',
  'users.email': 'Imèl',
  'common.yes': 'Wi',
  'common.no': 'Non',
  'common.cancel': 'Anile',
  'common.save': 'Sove',
  'common.search': 'Chèche',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Konekte',
  'login.welcome': 'Byenveni, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imèl',
  'signup.phone': 'Telefòn',
  'menu.reportsAndAccounting': 'Rapò & Kontablite',
  'menu.systemAndCommunication': 'Sistèm & Kominikasyon',
};